<template>
  <v-app-bar
    id="core-app-bar"
    absolute
    app
    :color="barColor"
    flat
    height="60"
  >
    <v-btn
      v-if="userHasAuthority('READ')"
      class="toolbar-items"
      icon
      to='/'
    >
      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-toolbar-title class="tertiary--text font-weight-light align-self-center">


      OBARA {{testEnvironment}} <template v-if="currentCustomer!='' && $vuetify.breakpoint.mdAndUp">  - {{ currentCustomer }}</template>

    </v-toolbar-title>

    <v-spacer/>

    <v-toolbar-items>
        <v-select
          dense
          light
          v-model="selectedLanguage"
          :items="locales"
          :item-text="'name'"
          :item-value="'locale'"

        ></v-select>
    </v-toolbar-items>

        <v-menu
          bottom
          left
          offset-y
          transition="slide-y-transition"
          v-if="userHasAuthority('MANAGE_SETTINGS')"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              class="toolbar-items"
              icon
              v-on="on"
            >
              <v-icon color="tertiary">
                mdi-cog-outline
              </v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-list dense>
              <v-list-item
                v-for="setting in settings"
                v-if="userHasAuthority(setting.requiredAuthority)"
                :key="setting.text"
                :to="setting.to"
              >
                <v-list-item-title v-text="$t(setting.text)"/>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-menu
          v-if="userHasAuthority('READ')"
          bottom
          left
          offset-y
          transition="slide-y-transition"
        >


          <template v-slot:activator="{ on }">
            <v-btn
              class="toolbar-items"
              icon
              v-on="on"
            >
              <v-icon color="tertiary">
                mdi-account
              </v-icon>
            </v-btn>
          </template>


          <v-card>
            <v-list dense>
              <v-list-item
                v-for="userSetting in userMenu"
                :key="userSetting.text"
                :to="userSetting.to"
              >
                <v-list-item-title v-text="$t(userSetting.text)"/>


              </v-list-item>
              <v-list-item
                key="userMenu.help"
                :href="helpFile"
                target="_blank"

              >
                <v-list-item-title v-text="$t('userMenu.help')"/>

              </v-list-item>
              <v-list-item
                key="userMenu.logout"
                to="/logout"
              >
                <v-list-item-title v-text="$t('userMenu.logout')"/>

              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>


  </v-app-bar>

</template>

<script>
    // Utilities
    import {
        mapMutations
    } from 'vuex'
    import languageUtil from '../../utils/language'


    export default {
        data: () => ({
            userMenu: [

                {
                    to: '',
                    text: '',
                },
                {
                    to: '/MyProfileEdit',
                    text: 'userMenu.myProfile',
                }


            ],



            settings: [


                {
                    to: '/workTypes',
                    text: 'menu.workTypes',
                    requiredAuthority: 'MANAGE_SETTINGS'
                },

                {
                    to: '/incidentTypes',
                    text: 'menu.incidentTypes',
                    requiredAuthority: 'MANAGE_SETTINGS'
                },
                {
                    to: '/locations',
                    text: 'menu.locations',
                    requiredAuthority: 'MANAGE_SETTINGS'
                },
              {
                to: '/departments',
                text: 'menu.departments',
                requiredAuthority: 'MANAGE_SETTINGS'
              },
                {
                    to: '/barrierOwners',
                    text: 'menu.barrierOwners',
                    requiredAuthority: 'MANAGE_SETTINGS'
                },
              {
                to: '/measureResponsibles',
                text: 'menu.measureResponsibles',
                requiredAuthority: 'MANAGE_SETTINGS'
              },
                {
                    to: '/consequenceTypes',
                    text: 'menu.consequenceTypes',
                    requiredAuthority: 'MANAGE_SETTINGS'
                },
                {
                    to: '/consequenceStrengths',
                    text: 'menu.consequenceStrengths',
                    requiredAuthority: 'MANAGE_SETTINGS'
                },
                {
                    to: '/probabilityLevels',
                    text: 'menu.probabilityLevels',
                    requiredAuthority: 'MANAGE_SETTINGS'
                },
                {
                    to: '/projectTypes',
                    text: 'menu.projectTypes',
                    requiredAuthority: 'MANAGE_SETTINGS'
                },
                {
                    to: '/users',
                    text: 'menu.users',
                    requiredAuthority: 'MANAGE_SETTINGS'
                },
                {
                    to: '/customers',
                    text: 'menu.customers',
                    requiredAuthority: 'MANAGE_CUSTOMERS'
                }

            ],

            responsive: false,

            locales: [],

            selectedLanguage: localStorage.getItem('language') || 'en',
            title:""
        }),


        computed: {
          helpFile() {return "/help/help_" + this.selectedLanguage + ".pdf" },
          barColor() {
            if (!this.$store.getters.productionEnvironment)
              return "yellow"
            else
              return "white"

          },
          testEnvironment() {
            if (!this.$store.getters.productionEnvironment)
              return " - TEST"
            else
              return ""

          },
            availableLanguages() {
                return this.$store.getters.availableLanguages
            }
        },

        mounted() {
            this.userMenu[0].text = this.currentUser
            this.onResponsiveInverted()
            window.addEventListener( 'resize', this.onResponsiveInverted)
            var v = this;
            setTimeout(function () {

                v.setLocales()
            }, 2000);



        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResponsiveInverted)
        },
      watch: {
          currentUser: function() {

              this.userMenu[0].text = this.currentUser
          },
          selectedLanguage: function (newLang) {
              this.$store.commit('setLanguage', newLang)
              localStorage.setItem('language', newLang)
            this.$i18n.i18next.changeLanguage(newLang, (err, t) => {
                  if (err) return console.log('something went wrong loading', err);
                  this.setLocales()
              });
          },
          availableLanguages: function () {
              this.setLocales()
          }

      },

        methods: {
            setLocales() {
                if (this.availableLanguages != null) {
                  this.locales = this.availableLanguages.map(function (l) {
                      return {'locale': l, 'name': languageUtil.getLanguageText(l)}
                  });

                }


            },
            ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
            onClick() {
                this.setDrawer(!this.$store.state.app.drawer)
            },
            onResponsiveInverted() {
                if (window.innerWidth < 991) {
                    this.responsive = true
                } else {
                    this.responsive = false
                }
            }
        }
    }
</script>

<style>
  /* Fix coming in v2.0.8 */
  #core-app-bar {
    width: auto;
  }

  #core-app-bar a {
    text-decoration: none;
  }
</style>

